import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { DailyReportService } from '../../../../daily-report.service';
import { takeUntil } from 'rxjs/operators';


@Component({
  standalone: false,
  selector: 'app-item-postings-wrapper',
  templateUrl: './item-postings-wrapper.component.html',
  styleUrls: ['./item-postings-wrapper.component.scss'],
})
export class ItemPostingsWrapperComponent implements OnInit, OnDestroy {
  @Input() data: any;
  @Input() options: any = {
    showActionsSection: true,
  };
  disableAddMenu = false;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private dailyReportService: DailyReportService,
    private cdRef: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    this.dailyReportService.disableAddMenu
      .pipe(takeUntil(this.onDestroy))
      .subscribe((d) => {
        this.disableAddMenu = d;
        try { this.cdRef.detectChanges(); } catch (e) { }
      });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
